import { render, staticRenderFns } from "./franchiseeToBBPayment.vue?vue&type=template&id=304a3d12&scoped=true"
import script from "./franchiseeToBBPayment.vue?vue&type=script&lang=js"
export * from "./franchiseeToBBPayment.vue?vue&type=script&lang=js"
import style0 from "./franchiseeToBBPayment.vue?vue&type=style&index=0&id=304a3d12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304a3d12",
  null
  
)

export default component.exports